var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer-top"}),_c('div',{staticClass:"footer-bottom"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('h4',{staticClass:"pull-center"},[_vm._v("Copyright ©2022 Empaques Lupa")])])])])])
}]

export { render, staticRenderFns }